import { render } from "./CourseEditView.vue?vue&type=template&id=74f296e2"
import script from "./CourseEditView.vue?vue&type=script&lang=js"
export * from "./CourseEditView.vue?vue&type=script&lang=js"

import exportComponent from "G:\\Projeto_ELITE\\VUE\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__